import type { RouteObject } from 'react-router';
import { paths } from '@shared/config/paths';
import { AddReceiptPage } from './pages/AddReceiptPage';
import { ReceiptsPage } from './pages/ReceiptsPage';

/** Routes exposées par la feature « receipts » à la coquille applicative. */
export const receiptsRoutes: RouteObject[] = [
  { path: paths.receipts, element: <ReceiptsPage /> },
  { path: paths.receiptNew, element: <AddReceiptPage /> },
];
